import { Controller } from "@hotwired/stimulus"

// One link handed to people (docs/espais.md §13): copy it, or pass it on
// through the device's own share sheet where there is one. The link stays
// visible and selectable underneath, so neither gesture is the only way.
export default class extends Controller {
  static targets = ["copy", "share"]
  static values = { url: String, title: String, copied: String }

  connect() {
    if (this.hasShareTarget && navigator.share) this.shareTarget.hidden = false
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
    } catch {
      return
    }
    const label = this.copyTarget.textContent
    this.copyTarget.textContent = this.copiedValue
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => { this.copyTarget.textContent = label }, 2000)
  }

  async share() {
    try {
      await navigator.share({ title: this.titleValue, url: this.urlValue })
    } catch {
      // Dismissing the sheet is not an error worth telling anyone about
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
